import axios from 'axios';

// API URL configuration:
// - In development: uses localhost:3000 (or REACT_APP_API_URL if set)
// - In production: uses relative URL '/api' (nginx proxies to backends)
const API_URL = process.env.REACT_APP_API_URL || 
  (window.location.hostname === 'localhost' && window.location.port === '3002'
    ? 'http://localhost:3000/api'
    : '/api');

const api = {
    // Generic HTTP methods
    post: async (url, data) => {
        const fullUrl = url.startsWith('/api') ? `${API_URL}${url.substring(4)}` : `${API_URL}${url}`;
        const response = await axios.post(fullUrl, data);
        return response;
    },
    get: async (url) => {
        const fullUrl = url.startsWith('/api') ? `${API_URL}${url.substring(4)}` : `${API_URL}${url}`;
        const response = await axios.get(fullUrl);
        return response;
    },
    
    // Manufacturer methods
    getManufacturers: async () => {
        const response = await axios.get(`${API_URL}/manufacturers`);
        return response.data;
    },
    getManufacturer: async (id) => {
        const response = await axios.get(`${API_URL}/manufacturers/${id}`);
        return response.data;
    },
    createManufacturer: async (manufacturer) => {
        const response = await axios.post(`${API_URL}/manufacturers`, manufacturer);
        return response.data;
    },
    updateManufacturer: async (id, manufacturer) => {
        const response = await axios.put(`${API_URL}/manufacturers/${id}`, manufacturer);
        return response.data;
    },
    deleteManufacturer: async (id) => {
        await axios.delete(`${API_URL}/manufacturers/${id}`);
    }

};

 export default api;